import { useEffect, useState } from 'react';

/** Radial sienna glow that follows the cursor. Pointer-events none so it
 * never steals clicks. Hidden below md in responsive.css. */
export function CursorSpotlight() {
  const [pos, setPos] = useState({ x: -9999, y: -9999 });

  useEffect(() => {
    const onMove = (e: MouseEvent) => setPos({ x: e.clientX, y: e.clientY });
    window.addEventListener('mousemove', onMove, { passive: true });
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  return (
    <div
      className="cursor-spotlight"
      aria-hidden
      style={{
        position: 'fixed',
        left: pos.x,
        top: pos.y,
        width: 520,
        height: 520,
        transform: 'translate(-50%, -50%)',
        pointerEvents: 'none',
        background: 'radial-gradient(circle, rgba(154,58,31,0.09) 0%, transparent 60%)',
        zIndex: 1,
      }}
    />
  );
}
